import { useState } from 'react';

const FAQ_ITEMS = [
  {
    q: '谜妹漫画支持哪些类型的漫画？',
    a: '谜妹漫画涵盖韩漫、日漫、国漫三大类别，细分悬疑漫画、恋爱漫画、搞笑漫画、奇幻漫画、都市漫画、古风漫画等20余个品类，满足不同口味的漫画爱好者。',
  },
  {
    q: '阅读是否需要付费？',
    a: '谜妹漫画提供大量免费漫画资源，支持下拉式流畅阅读体验。部分独家内容可能需要消耗少量积分，但每日签到和任务均可免费获取积分。',
  },
  {
    q: '如何找到我想看的漫画？',
    a: '您可以通过顶部分类导航按韩漫、日漫、国漫筛选，也可以使用搜索功能按作品名或作者名查找。首页的热门话题和精选推荐也会帮您发现高分好漫。',
  },
  {
    q: '支持手机和电脑阅读吗？',
    a: '完全支持。谜妹漫画采用响应式设计，在手机、平板和电脑端均可流畅阅读。下拉式翻页在移动端体验尤为顺滑，无需额外安装插件。',
  },
  {
    q: '漫画更新频率如何？',
    a: '热门连载漫画每日同步更新，新作入库速度也非常快。韩漫区每月新增200+部作品，日漫和国漫区各有100+部新作上架，确保您追更不停。',
  },
  {
    q: '遇到无法打开或加载慢怎么办？',
    a: '建议检查网络连接是否稳定，或尝试刷新页面。如问题持续存在，可切换至备用线路。网页版推荐使用Chrome或Safari浏览器以获得最佳阅读体验。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            关于谜妹漫画，您可能想了解这些
          </p>
        </div>

        <div className="space-y-3">
          {FAQ_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className="border border-background-200/70 rounded-xl overflow-hidden bg-background-50"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <h3 className="font-medium text-sm md:text-base text-foreground-800 pr-4">
                  {item.q}
                </h3>
                <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-colors ${openIndex === idx ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'}`}>
                  <i className={`text-sm transition-transform duration-300 ${openIndex === idx ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </span>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}